import classNames from "classnames";
import React from "react";

export type CaVerticalNavigationProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

function CaVerticalNavigation({ children, className, style }: CaVerticalNavigationProps) {
  return (
    <nav
      className={classNames(
        "flex flex-col justify-start items-start gap-2.5 w-full p-2.5 bg-white rounded-base border border-light-neutral-2",
        className,
      )}
      style={style}
    >
      {children}
    </nav>
  );
}

export default CaVerticalNavigation;
